import React, { useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import ReCaptchaV2 from 'react-google-recaptcha';

import { Button } from '../../Atoms';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from 'emailjs-com';

export default function ContactForm({ className }) {
  const [isLoading, setLoading] = useState(false);
  const [isVerified, setVerified] = useState(false);
  const [token, setToken] = useState(null);

  const FullScreenLoader = () => {
    return (
      <section className="fixed z-[1000] top-0 left-0 right-0 bottom-0 bg-black bg-opacity-30 grid place-content-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="120px"
          height="120px"
          className="h-24 w-24 "
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke="#24B354"
            strokeWidth="10"
            r="35"
            strokeDasharray="164.93361431346415 56.97787143782138"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              repeatCount="indefinite"
              dur="1s"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
            ></animateTransform>
          </circle>
        </svg>
      </section>
    );
  };
  const initalFormState = {
    email: '',
    fullName: '',
    phone: '',
    message: '',
  };

  let captchaRef = useRef();

  const validator = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid Email Address';
    }
    if (!/^\d{6,15}$/.test(values.phone)) {
      errors.phone = 'Enter valid phone number';
    } else if ((values.phone + '').length < 8) {
      errors.phone = 'Phone number should be more than 8 digits.';
    }

    if (values.fullName === '') {
      errors.fullName = 'This field is required.';
    }
    if (values.last_name === '') {
      errors.last_name = 'This field is required.';
    }
    return errors;
  };

  const templateID = process.env.REACT_APP_TEMPLATE_ID ?? '';
  const serviceID = process.env.REACT_APP_SERVICE_ID ?? '';
  const publicKey = process.env.REACT_APP_PUBLIC_KEY ?? '';
  const verificationKey = process.env.REACT_APP_CAPTCHA_KEY ?? '';

  // console.log(templateID, serviceID, publicKey);

  const submitHandler = (values, { resetForm }) => {
    const formPayload = Object.assign(values, { token: token, 'g-recaptcha-response': token });
    setLoading(true);
    try {
      emailjs
        .send(serviceID, templateID, formPayload, publicKey)
        .then(
          function (response) {
            setLoading(false);
            resetForm();
            captchaRef.current.reset();
            setToken(null);
            setVerified(false);
            toast.success('Form has been submitted successfully.');
          },
          function (err) {
            setLoading(false);
            resetForm();
            captchaRef.current.reset();
            setToken(null);
            setVerified(false);
            toast.error('Error occured. Please try again.');
          }
        )
        .catch(() => {
          resetForm();
          captchaRef.current.reset();
          setToken(null);
          setVerified(false);
          setLoading(false);
          toast.error('Error occured! Please try after some time.');
        });
    } catch (error) {
      resetForm();
      captchaRef.current.reset();
      setToken(null);
      setVerified(false);
      setLoading(false);
      toast.error('Error occured! Please try after some time.');
    }
  };

  const handleToken = (token) => {
    setToken(token);
    setVerified(true);
  };
  const handleExpire = () => {
    setToken(null);
    setVerified(false);
  };

  return (
    <div
      id="contact-us"
      className={`${className}  xLg:py-0 py-16 flex items-center `}
    >
      <ToastContainer />

      {isLoading ? <FullScreenLoader /> : ''}
      <div className={className ? 'xxl:w-9/12 xl:w-9/12 w-10/12 mx-auto max-w-screen-md bg-black p-9 rounded-xl' : 'xxl:w-9/12 xl:w-9/12 w-10/12 xxl:ml-32 xLg:ml-14 mx-auto max-w-screen-md bg-black p-9 rounded-xl'}>
        <h5 className="text-white text-left xxl:text-4xl text-3xl leading-tight md:font-gilroybold font-gilroy">
          Send us a Message
        </h5>
        <h6
          className={`text-white text-left xxl:text-2xl text-lg font-gilroylight md:mt-2`}
        >
          Our team will be happy to help you out!
        </h6>

        <div className="relative overflow-hidden">
          <Formik
            initialValues={initalFormState}
            validate={(values) => validator(values)}
            onSubmit={(values, actions) => submitHandler(values, actions)}
            validateOnChange={false}
          >
            {({
              values,
              errors,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                noValidate
                className="w-full  xl:mt-8 mt-4"
              >
                <div className="flex flex-wrap gap-x-5 md:gap-y-4">
                  <label
                    htmlFor="fullName"
                    className=" basis-72 flex-1 grow shrink flex flex-col text-base gap-1 items-start uppercase font-poppins font-medium text-black"
                  >
                    {/* Full Name* */}
                    <input
                      type="text"
                      size="2"
                      id="fullName"
                      name="fullName"
                      placeholder="Full Name"
                      value={values.fullName}
                      onChange={handleChange}
                      className="mt-1 w-full bg-white bg-opacity-20 border-b-2 border-bgGreen outline-none text-base xl:text-lg px-3 py-2  rounded font-gilroy text-white tracking-wider focus:bg-bgGreen focus:bg-opacity-30"
                    />
                    <small className="text-danger text-sm h-6 font-poppins normal-case ">
                      {errors.fullName}
                    </small>
                  </label>
                </div>

                <div className="flex flex-wrap gap-x-5 md:gap-y-4 ">
                  <label
                    htmlFor="email"
                    className="basis-72 flex-1 text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase"
                  >
                    Email Address*
                    <input
                      type="text"
                      size="2"
                      id="email"
                      name="email"
                      placeholder="Email Address"
                      value={values.email}
                      onChange={handleChange}
                      className="mt-1 w-full bg-white bg-opacity-20 border-b-2 border-bgGreen outline-none text-base xl:text-lg px-3 py-2  rounded font-gilroy text-white tracking-wider focus:bg-bgGreen focus:bg-opacity-30"
                    />
                    <small className="text-danger text-sm h-6 font-poppins normal-case ">
                      {errors.email}
                    </small>
                  </label>
                  <label
                    htmlFor="phone"
                    className=" basis-72 flex-1 text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase"
                  >
                    Phone Number*
                    <input
                      type="number"
                      size="2"
                      id="phone"
                      name="phone"
                      placeholder="+91 XXXX XXXXXX"
                      value={values.phone}
                      onChange={handleChange}
                      className="mt-1 w-full bg-white bg-opacity-20 border-b-2 border-bgGreen outline-none text-base xl:text-lg px-3 py-2  rounded font-gilroy text-white tracking-wider focus:bg-bgGreen focus:bg-opacity-30"
                    />
                    <small className="text-danger text-sm h-6 font-poppins normal-case ">
                      {errors.phone}
                    </small>
                  </label>
                </div>
                <label
                  htmlFor="message"
                  className="basis-80 text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase xl:my-2"
                >
                  Message
                  <textarea
                    name="message"
                    id="message"
                    cols="10"
                    rows="4"
                    onChange={handleChange}
                    className="mt-1 w-full bg-white bg-opacity-20 border-b-2 border-bgGreen outline-none text-base xl:text-lg px-3 py-2  rounded font-gilroy text-white tracking-wider focus:bg-bgGreen focus:bg-opacity-30"
                    placeholder="Message"
                  ></textarea>
                </label>

                <div className="captcha-wrapper h-20">
                  <ReCaptchaV2
                    sitekey={verificationKey}
                    ref={captchaRef}
                    onChange={handleToken}
                    onExpired={handleExpire}
                  />
                </div>

                <Button
                  isSubmitBtn={true}
                  className="mt-10 xl:mt-8 mx-auto"
                  title="Send"
                  isDisabled={!isVerified}
                  whitebtn
                />
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
